module.exports = __webpack_public_path__ + "img/yuyin-coupon-bg.ae1e408f.png";